<template>
  <div>
    <div class="my_info mainBgColor">
      <div class="currency_box">
        <el-image class="my_img"
                  :src="info.headImg"></el-image>
        <div class="my_content">
          <div class="font20">{{info.userName}}，晚上好</div>
          <div class="font14"
               style="margin-top:12px">知识是一种快乐，而好奇则是知识的萌芽。</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      info: {},
      isLogin: false,
    }
  },
  created () {
    if (localStorage.getItem('accessToken') && localStorage.getItem('accessToken') != '') {
      this.isLogin = true;
      this.info = JSON.parse(localStorage.getItem('info'))
    } else {
      this.isLogin = false;
    }
  }
}
</script>
<style lang="less" scoped>
.my_info {
  padding: 32px 0;
  box-sizing: border-box;
  .my_img {
    width: 86px;
    height: 86px;
    margin-right: 20px;
    border-radius: 50%;
  }
  .my_content {
    flex: 1;
    text-align: left;
    color: #fff;
  }
}
</style>